export default class TaskMoveRequestModel {
  TaskId!: number;
  NewQueueTaskId!: string;
  /**
   * * Номер статуса который необходим выставить в новой очереди
   */
  StatusId?: number;
  constructor(obj?: Partial<TaskMoveRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
